import { skipDefaultRequestHeadersKey } from './sensitive-call'
import { authInterceptor } from './auth-interceptor'
import { proxyInterceptor } from './proxy-interceptor'
import { sentryInterceptor } from './sentry-interceptor'
import { traceInterceptor } from './telemetry-interceptor'

import type { Interceptor } from '@connectrpc/connect'

type RequestHeadersProvider = () => HeadersInit | undefined

let requestHeadersProvider: RequestHeadersProvider | undefined

export function setRpcRequestHeadersProvider(provider: RequestHeadersProvider | undefined) {
  requestHeadersProvider = provider
}

export function getDefaultRpcRequestHeaders(): Headers {
  return new Headers(requestHeadersProvider?.())
}

const requestHeadersInterceptor: Interceptor = next => request => {
  if (request.contextValues.get(skipDefaultRequestHeadersKey)) {
    return next(request)
  }
  getDefaultRpcRequestHeaders().forEach((value, name) => {
    if (!request.header.has(name)) {
      request.header.set(name, value)
    }
  })
  return next(request)
}

export const interceptors = [
  proxyInterceptor,
  requestHeadersInterceptor,
  authInterceptor,
  sentryInterceptor,
  traceInterceptor,
]
